import { render } from "./TopUp.vue?vue&type=template&id=ae608f5e&scoped=true"
import script from "./TopUp.vue?vue&type=script&lang=js"
export * from "./TopUp.vue?vue&type=script&lang=js"

import "./TopUp.vue?vue&type=style&index=0&id=ae608f5e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae608f5e"]])

export default __exports__